// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"529d8ed7","455":"8f8ae16b","977":"6aa11c32"}[chunkId] + ".chunk.js";
};